import axiosInstance from "../app/axios";
import { MultipleLoadDTO } from "../shared/dtos/multipleLoadDTO";

export const multipleLoadApi = async (data: MultipleLoadDTO) => {
  const result = await axiosInstance.post("trip/bulk/request", {
    ...data,
  });
  return result.data;
};

export const mergeLoadApi = async (data: MultipleLoadDTO) => {
  const result = await axiosInstance.post("trip/merge/request", {
    ...data,
  });
  return result.data;
};
